var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 .75c.916 0 1.747.334 2.339.926.57.57.911 1.375.911 2.324v12a3.24 3.24 0 0 1-.952 2.298A3.24 3.24 0 0 1 16 19.25H4a3.24 3.24 0 0 1-2.298-.952A3.24 3.24 0 0 1 .75 16V4c0-.897.364-1.71.952-2.298A3.24 3.24 0 0 1 4 .75z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 1,
    x: 5.75,
    y: 9.75,
    rx: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiOption);
export default __webpack_public_path__ + "static/media/multi-option.85e3442f.svg";
export { ForwardRef as ReactComponent };